import { useSelector } from "react-redux";

export default function useEntityIds(entity) {
  return useSelector((state) => state.entities[entity]?.allIds);
}
